var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.icon)?_c('span',{staticClass:"triangle"},[_vm._v(_vm._s(_vm.icon)+" ")]):_vm._e(),_vm._v(_vm._s(_vm.temp)+"°c ")])}
var staticRenderFns = []

export { render, staticRenderFns }